import { render, staticRenderFns } from "./NonTransferableGuestsTab.vue?vue&type=template&id=08a6d8ed&"
import script from "./NonTransferableGuestsTab.vue?vue&type=script&lang=ts&"
export * from "./NonTransferableGuestsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports